import {
  ApPayeeSelectedValueProvider,
  BookDateSelectedValueProvider,
} from '@/components/ReportForm';
import { FC, PropsWithChildren, createContext, memo, useContext } from 'react';

const apiContext = createContext(false);
export const useIsLoadingWithAllApi = () => useContext(apiContext);

export const ComponentAPI: FC<PropsWithChildren> = memo(({ children }) => {
  return (
    <ApPayeeSelectedValueProvider>
      <BookDateSelectedValueProvider>
        <InnerComponentAPI>{children}</InnerComponentAPI>
      </BookDateSelectedValueProvider>
    </ApPayeeSelectedValueProvider>
  );
});
ComponentAPI.displayName = 'ComponentAPI';

const InnerComponentAPI: FC<PropsWithChildren> = memo(({ children }) => {
  return <apiContext.Provider value={false}>{children}</apiContext.Provider>;
});
InnerComponentAPI.displayName = 'InnerComponentAPI';
